import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'blog-block',
    templateUrl: './blog-block.component.html',
    styleUrls: ['./blog-block.component.scss'],
    standalone: false
})
export class BlogBlockComponent implements OnInit {
  @Input() info;

  public videoUrl;
  public opacityColor;

  constructor(private _sanitizer: DomSanitizer) {}

  ngOnInit() {
    if (this.info && this.info.video) {
      if (this.info.video.indexOf('embed') !== -1) {
        this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.info.video
        );
      } else {
        this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.parseYoutube(this.info.video)
        );
      }
    }
    this.opacityColor = this.hexToRGB('#FFFFFF', 0.3);
  }
  hexToRGB(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }
  parseYoutube(url) {
    let link = 'https://www.youtube.com/embed/';
    const videoId = url.split('?v=');
    link = link + videoId[1];
    return link;
  }

}
